__turbopack_context__.v({
  "container": "Checkbox-module-scss-module__fkA90a__container",
  "content": "Checkbox-module-scss-module__fkA90a__content",
  "input": "Checkbox-module-scss-module__fkA90a__input",
  "label": "Checkbox-module-scss-module__fkA90a__label",
  "overlay": "Checkbox-module-scss-module__fkA90a__overlay",
  "shape": "Checkbox-module-scss-module__fkA90a__shape",
});
